import { useState, useEffect, useCallback } from "react";
import "@/index.css";
import LoginPage from "@/components/LoginPage";
import HomePage from "@/components/HomePage";

const API = `/api`;

function App() {
  const [token, setToken] = useState(null);
  const [isChecking, setIsChecking] = useState(true);

  // Check if saved token is still valid
  const checkToken = useCallback(async (savedToken) => {
    try {
      const response = await fetch(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${savedToken}` },
      });
      if (response.ok) {
        setToken(savedToken);
      } else {
        localStorage.removeItem("home-token");
      }
    } catch {
      localStorage.removeItem("home-token");
    } finally {
      setIsChecking(false);
    }
  }, []);

  useEffect(() => {
    const savedToken = localStorage.getItem("home-token");
    if (savedToken) {
      checkToken(savedToken);
    } else {
      setIsChecking(false);
    }
  }, [checkToken]);

  // Detect dark mode preference
  useEffect(() => {
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (prefersDark) {
      document.documentElement.classList.add("dark");
    }
  }, []);

  const handleLogin = (newToken) => {
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem("home-token");
    setToken(null);
  };

  if (isChecking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  if (!token) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return <HomePage onLogout={handleLogout} />;
}

export default App;
